module.exports = __webpack_public_path__ + "img/pro_seven_5.53c493a1.jpg";